import api from '../client';

export const AuthService = {
  register: (data) => api.post('/auth/register', data),
};
